<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="company">
        <el-input v-model="queryParams.company" filterable placeholder="公司名称" @keyup.enter.native="search" clearable> </el-input>
      </el-form-item>
      <el-form-item  prop="contact">
        <el-input v-model="queryParams.contact" placeholder="联系人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="phone">
        <el-input v-model="queryParams.phone" placeholder="联系号码" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="intention">
        <el-select v-model="queryParams.intention" filterable placeholder="合作意向" @change="search" clearable>
          <el-option
            v-for="item in intentionOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" ref="tableData" border v-loading="loading" @sort-change="tableSortChange">
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="platformFrom" label="来源平台" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="company" label="公司名称" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="contact" label="联系人" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="phone" label="联系号码" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="email" label="邮箱" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="intentionLabel" label="合作意向" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="message" label="留言内容" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="留言时间" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="80" align="center" fixed="right">
        <!-- <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="detailInfo(scope.row)">详情</el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
            v-show="total>0"
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="initData"
    />
  </div>
</template>

<script>
  import { clientNoteList } from "@/api/api.js";

  export default {
    name: 'clientNote',
    data () {
      return {
        loading: false,
        dateRange: [],
        queryParams: {
          company: undefined,
          contact: undefined,
          phone: undefined,
          email: undefined,
          intention: undefined
        },
        tableData: [{
          id: undefined,
          company: undefined,
          contact: undefined,
          phone: undefined,
          email: undefined,
          intention: undefined,
          intentionLabel: undefined,
          message: undefined,
          platformFrom: undefined,
          createTime: undefined,
          status: undefined
        }],
        intentionOptions: [
            {
              "value": "security",
              "label": "安防监控"
            },
            {
              "value": "vehicle",
              "label": "车联网"
            },
            {
              "value": "smart-home",
              "label": "智能家居"
            },
            {
              "value": "industry",
              "label": "工业物联网"
            },
            {
              "value": "other",
              "label": "其他"
            }
        ],
        searchTime: [],
        page: 1,
        pageSize: 20,
        total: 0,
        agentOptions: [],
        // 排序方式
        sortOrder: "",
        // 排序名称
        sortName: "",
      }
    },
    computed: {
      adminShow () {
        return this.$store.getters.user.userType == "1";
      }
    },
    methods: {
      transIntention(val) {
        const foundItem = this.intentionOptions.find(item => 
          item.value === val || item.label === val
        );
        return foundItem ? foundItem['label'] : null;
      },
      // 搜索
      search () {
        this.tableData = [];
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.dateRange = [];
        this.resetForm("queryForm");
        this.search();
      },
      // 排序
      tableSortChange (val) {
        this.sortOrder = val.order == "descending" ? "desc" : "asc";
        this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
        this.initData();
      },
      // 获取列表的数据
      initData () {
        let params = {
          model: {
            ... this.addDateRange(this.queryParams, this.dateRange),
            order: this.sortOrder,
            sort: this.sortName,
          },
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        clientNoteList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.tableData.map((item, index) => {
            item.ids = index + 1,
            item.intentionLabel = this.transIntention(item.intention);
          })
          this.total = res.data.data.total;
        })
      }
    },
    mounted () {
      this.initData();
    },
    created () {},
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.name == "clientNote") {
                    this.initData();
                }
            },
            // 深度观察监听
            deep: true,
        },
    },
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
